export default __webpack_public_path__ + "e9417c3ba642cc8d68ebe11da47a25e0.png";